import React from "react";
import "./formStep.css";

const FormStep = (
  props: React.PropsWithChildren<{ header: React.ReactComponentElement<any> }>
) => {
  return (
    <div>
      {props.header}
      {props.children}
    </div>
  );
};

export default FormStep;
